import React, { useEffect } from "react";
import { Form } from "react-bootstrap"
import { RequiredLabel } from "./RequiredLabel";

export const CheckField = ({ format, setValue, watch, field, control, fieldErrors, validation, getValues, data, rowIdentity, isUnique, required, register, errors, formState, editTableProps }) => {
  
  const hide = field.hideIf ? field.hideIf({editTableProps, rowIdentity, watch}) : false;
  const registration = register(field.name);
  return !hide && (
    <Form.Group className="mb-1" title={field.tooltip}>
      {field.label && <RequiredLabel label={field.label} required={required} />}
      <Form.Check
        disabled={field.disabled ? field.disabled({ watch, editTableProps }) : undefined}
        aria-label={field.label}
        style={{ position: 'relative !important' }}
        className="checkbox-field-custom"
        {...registration}
        onChange={async (e) => {
          await registration.onChange(e);
          field.onChange?.({ getValues, setValue, evt: e });
        }}
        type="switch"
        formControlName={field.name}
        label={""}
      />
    </Form.Group>
  );
}